{
  "generic": {
    "submitting": "Submitting...",
    "submit": "Submit",
    "cancel": "Cancel",
    "submitted": "Submitted!",
    "failed": "Failed",
    "submit_feedback": "Submit feedback"
  },
  "auth": {
    "login": {
      "title": "Login",
      "welcome_back": "Welcome Back",
      "subtitle": "Log in to your account",
      "university_subtitle": "Log in to your university account",
      "company_subtitle": "Log in to your company account",
      "platform_subtitle": "Log in to your platform admin account",
      "select_role_label": "Select Your Role",
      "university": "University",
      "company": "Company",
      "other": "Other",
      "username_placeholder": "Username or Email",
      "password_placeholder": "Password",
      "forgot_password": "Forgot Password?",
      "login_button": "Login",
      "logging_in": "Logging in...",
      "signup_text": "Don't have an account?",
      "signup_link": "Sign Up",
      "invalid_credentials": "Invalid username or password",
      "loading": "Loading...",
      "form_title": "Enter the range.",
      "hero_line1_prefix": "Train like",
      "hero_line1_highlight": "adversaries",
      "hero_line2_prefix": "Defend like",
      "hero_line2_highlight": "architects"
    },
    "shell": {
      "enterprise_tagline": "Enterprise Cyber Range",
      "footer": "© {{year}} Quantum Vanguard. All systems nominal."
    },
    "company_login": {
      "tagline": "Enterprise Portal",
      "hero_line1_prefix": "Defend the",
      "hero_line1_highlight": "enterprise",
      "hero_line2_prefix": "Train the",
      "hero_line2_highlight": "workforce",
      "form_eyebrow": "Enterprise sign-in",
      "form_title": "Welcome back."
    },
    "platform_login": {
      "tagline": "Platform Administration",
      "hero_line1_prefix": "Govern the",
      "hero_line1_highlight": "range",
      "hero_line2_prefix": "Shape the",
      "hero_line2_highlight": "platform",
      "form_eyebrow": "Platform admin sign-in",
      "form_title": "Operator console."
    },
    "university_login": {
      "tagline": "University Portal",
      "hero_line1_prefix": "Teach like",
      "hero_line1_highlight": "researchers",
      "hero_line2_prefix": "Learn like",
      "hero_line2_highlight": "operators",
      "form_eyebrow": "University sign-in",
      "form_title": "Welcome back."
    },
    "registration": {
      "tagline": "Registration Portal",
      "student_form_eyebrow": "Student sign-up",
      "professional_form_eyebrow": "Professional sign-up",
      "role_selection_form_eyebrow": "Account selection",
      "student_hero": {
        "prefix": "Create your",
        "highlight": "personal",
        "suffix": "account."
      },
      "professional_hero": {
        "prefix": "Create your",
        "highlight": "professional",
        "suffix": "account."
      },
      "role_selection_hero": {
        "line1_prefix": "Choose your",
        "line1_highlight": "role",
        "line2_prefix": "Enter the",
        "line2_highlight": "range"
      }
    },
    "forgot_password": {
      "title": "Reset password",
      "description": "Enter your email and we'll send a reset link if an account exists.",
      "email_placeholder": "Enter email",
      "send_button": "Send Reset Link",
      "sending": "Sending...",
      "cancel": "Back to login",
      "success_message": "Password reset link has been sent to your email.",
      "error_message": "Failed to send reset link. Please try again."
    },
    "api_messages": {
      "username_password_required": "Username and password required",
      "invalid_token_response": "Invalid token response from server",
      "email_verification_required": "Email verification required. Please check your email and verify your account before logging in.",
      "invalid_username_password": "Invalid username or password",
      "refresh_token_required": "Refresh token required",
      "failed_refresh_token": "Failed to refresh token",
      "logged_out_success": "Successfully logged out",
      "logout_completed": "Logout completed",
      "failed_user_info": "Failed to retrieve user information",
      "email_required": "Email is required",
      "user_not_found": "User not found",
      "current_new_password_required": "Current password and new password are required",
      "password_updated_success": "Password updated successfully",
      "failed_update_password": "Failed to update password",
      "employee_email_required": "Employee email is required",
      "company_lookup_not_integrated": "Company lookup is not yet integrated; no match information available.",
      "email_already_registered": "Email already registered",
      "email_already_verified": "Email already verified. Please sign in.",
      "username_already_taken": "Username already taken",
      "invalid_role_self_registration": "Invalid role for self-registration. Only 'student' or 'company_user' allowed",
      "registration_success": "Registration successful. Please verify your email before logging in.",
      "failed_register_user": "Failed to register user",
      "permission_denied_promote": "Permission denied. Only platform administrators can promote users.",
      "student_role_cannot_change": "User has 'student' role. Student role cannot be changed to company_user or company_admin.",
      "user_not_company_user": "User does not have 'company_user' role. Cannot promote users without this role.",
      "user_already_company_admin": "User already has 'company_admin' role. Cannot promote again.",
      "promoted_to_company_admin": "User successfully promoted to company_admin",
      "failed_promote_user": "Failed to promote user",
      "password_reset_sent": "If an account exists for this email, a password reset link has been sent.",
      "rate_limit_exceeded": "Too many login attempts. Please wait and try again."
    },
    "validation": {
      "string_too_short": "{{field}} must be at least {{min}} characters",
      "string_too_long": "{{field}} must be at most {{max}} characters",
      "missing": "{{field}} is required",
      "pattern": "{{field}} format is invalid",
      "invalid_email": "Please enter a valid email address",
      "invalid": "{{field}} is invalid",
      "fields": {
        "password": "Password",
        "confirm_password": "Confirm password",
        "email": "Email",
        "username": "Username",
        "first_name": "First name",
        "last_name": "Last name",
        "designation": "Designation",
        "dob": "Date of birth"
      }
    },
    "role_selection": {
      "title": "Select Your Role",
      "default_description": "Choose the account type that best fits your needs",
      "continue_button": "Continue",
      "signin_text": "Already have an account?",
      "signin_link": "Sign In",
      "role_placeholder": "Select your role...",
      "roles": {
        "employee_label": "Company User",
        "private_label": "Student",
        "professional_label": "Professional",
        "employee_description": "As a Company User, you will utilize security tools, complete required training, and enhance your digital privacy and security awareness.",
        "private_description": "As a Student, you will control your personal data, access individual training resources, and enhance your digital privacy and security awareness.",
        "professional_description": "As a Professional, you will access advanced training paths, professional labs, and role-based learning resources."
      }
    },
    "step_progress": {
      "label": "Step {{current}}: {{label}}"
    },
    "company_user_registration": {
      "step1": {
        "progress_label": "Account Setup",
        "title": "Create Your Employee Account",
        "description": "Enter your company email address to get started with your employee registration.",
        "email_label": "Employee Email Address",
        "email_placeholder": "Enter your email",
        "next_button": "Next"
      },
      "step2": {
        "title": "Company Found",
        "description": "Is this your company? Please confirm the details below.",
        "company_label": "Company:",
        "industry_label": "Industry:",
        "wrong_company_button": "No, wrong company",
        "confirm_button": "Yes, this is my company"
      },
      "step3": {
        "progress_label": "Account Details",
        "title": "Tell Us About Yourself",
        "first_name_label": "First Name",
        "first_name_placeholder": "Enter your first name",
        "last_name_label": "Last Name",
        "last_name_placeholder": "Enter your last name",
        "username_label": "Username",
        "username_placeholder": "Choose a username",
        "phone_label": "Phone Number",
        "phone_optional": "(optional)",
        "phone_placeholder": "e.g., +92xxxxxxxxxx",
        "designation_label": "Designation",
        "designation_placeholder": "e.g. Software Engineer",
        "password_label": "Password",
        "password_placeholder": "Enter your password",
        "confirm_password_label": "Confirm Password",
        "confirm_password_placeholder": "Confirm your password",
        "phone_error": "Phone must start with + or 1-9, followed by 1-14 digits (e.g., +92xxxxxxxxxx)",
        "password_error": "Passwords do not match",
        "next_button": "Next",
        "back_button": "Go Back & Edit"
      },
      "step4": {
        "progress_label": "Confirm Details",
        "title": "Confirm Your Employee Profile",
        "email_label": "Email",
        "company_label": "Company",
        "name_label": "Name",
        "username_label": "Username",
        "phone_label": "Phone Number",
        "designation_label": "Designation",
        "terms_text": "I agree to the",
        "terms_link": "Terms of Service",
        "and_text": "and",
        "privacy_link": "Privacy Policy",
        "submit_button": "Confirm & Complete Setup",
        "submitting": "Submitting...",
        "back_button": "Go Back & Edit",
        "error": "Registration failed. Please try again."
      },
      "step5": {
        "title": "Thank you for registering with us.",
        "subtitle": "Please verify your email",
        "sent_to": "We've sent a verification link to:",
        "check_inbox": "Please check your inbox and click the link to verify your email.",
        "expires": "Link expires in 12 hours.",
        "login_button": "Go to Login",
        "resend_text": "Didn't receive the email?",
        "resend_link": "Resend"
      },
      "email_exists": {
        "title": "This email is already registered",
        "body": "If you haven't verified yet, we can resend your verification link.",
        "resend_button": "Resend verification email",
        "resending": "Resending...",
        "login_button": "Go to Login",
        "resend_toast": "If an account exists for {{email}}, a verification email has been sent.",
        "resend_error": "We couldn't resend the verification email. Please try again."
      },
      "email_verified": {
        "title": "This email is already verified",
        "body": "Your account is ready. Please sign in to continue.",
        "login_button": "Go to Login"
      },
      "common": {
        "signin_text": "Already have an account?",
        "signin_link": "Sign In"
      }
    },
    "professional_registration": {
      "step1": {
        "progress_label": "Account Setup",
        "title": "Create Your Professional Account",
        "description": "Enter your professional email address to get started.",
        "email_label": "Professional Email Address",
        "email_placeholder": "Enter your email",
        "next_button": "Next"
      },
      "step2": {
        "title": "Professional Profile",
        "description": "Confirm your professional track and focus.",
        "track_label": "Track:",
        "focus_label": "Focus:",
        "track_value": "Professional Track",
        "focus_value": "Security Operations",
        "wrong_track_button": "No, choose another",
        "confirm_button": "Continue"
      },
      "step3": {
        "progress_label": "Account Details",
        "title": "Tell Us About Yourself",
        "first_name_label": "First Name",
        "first_name_placeholder": "Enter your first name",
        "last_name_label": "Last Name",
        "last_name_placeholder": "Enter your last name",
        "username_label": "Username",
        "username_placeholder": "Choose a username",
        "phone_label": "Phone Number",
        "phone_optional": "(optional)",
        "phone_placeholder": "e.g., +92xxxxxxxxxx",
        "designation_label": "Designation",
        "designation_placeholder": "e.g. Security Analyst",
        "password_label": "Password",
        "password_placeholder": "Enter your password",
        "confirm_password_label": "Confirm Password",
        "confirm_password_placeholder": "Confirm your password",
        "phone_error": "Phone must start with + or 1-9, followed by 1-14 digits (e.g., +92xxxxxxxxxx)",
        "password_error": "Passwords do not match",
        "next_button": "Next",
        "back_button": "Go Back & Edit"
      },
      "step4": {
        "progress_label": "Confirm Details",
        "title": "Confirm Your Professional Profile",
        "email_label": "Email",
        "track_label": "Track",
        "name_label": "Name",
        "username_label": "Username",
        "phone_label": "Phone Number",
        "designation_label": "Designation",
        "terms_text": "I agree to the",
        "terms_link": "Terms of Service",
        "and_text": "and",
        "privacy_link": "Privacy Policy",
        "submit_button": "Confirm & Complete Setup",
        "submitting": "Submitting...",
        "back_button": "Go Back & Edit",
        "error": "Registration failed. Please try again."
      },
      "step5": {
        "title": "Thank you for registering with us.",
        "subtitle": "Please verify your email",
        "sent_to": "We've sent a verification link to:",
        "check_inbox": "Please check your inbox and click the link to verify your email.",
        "expires": "Link expires in 12 hours.",
        "login_button": "Go to Login",
        "resend_text": "Didn't receive the email?",
        "resend_link": "Resend"
      },
      "email_exists": {
        "title": "This email is already registered",
        "body": "If you haven't verified yet, we can resend your verification link.",
        "resend_button": "Resend verification email",
        "resending": "Resending...",
        "login_button": "Go to Login",
        "resend_toast": "If an account exists for {{email}}, a verification email has been sent.",
        "resend_error": "We couldn't resend the verification email. Please try again."
      },
      "email_verified": {
        "title": "This email is already verified",
        "body": "Your account is ready. Please sign in to continue.",
        "login_button": "Go to Login"
      },
      "common": {
        "signin_text": "Already have an account?",
        "signin_link": "Sign In"
      }
    },
    "student_registration": {
      "step1": {
        "progress_label": "Step 1: Account Setup",
        "progress_count": "1/4",
        "title": "Create Your Personal Account",
        "email_label": "Personal Email Address",
        "email_placeholder": "Enter email",
        "next_button": "Next"
      },
      "step2": {
        "progress_label": "Step 2: Account Details",
        "progress_count": "2/4",
        "title": "Tell Us About Yourself",
        "first_name_label": "First Name",
        "first_name_placeholder": "Enter first name",
        "last_name_label": "Last Name",
        "last_name_placeholder": "Enter last name",
        "username_label": "Username",
        "username_optional": "(Optional)",
        "username_placeholder": "Choose username",
        "phone_label": "Phone Number",
        "phone_optional": "(Optional)",
        "phone_placeholder": "e.g., +92xxxxxxxxxx",
        "dob_label": "Date of Birth",
        "dob_optional": "(Optional)",
        "dob_placeholder": "Select date",
        "interests_label": "User Interests",
        "interests_optional": "(Optional)",
        "interests_placeholder": "Select interests",
        "password_label": "Password",
        "password_placeholder": "Enter password",
        "confirm_password_label": "Confirm Password",
        "confirm_password_placeholder": "Confirm password",
        "phone_error": "Phone must start with + or 1-9, followed by 1-14 digits (e.g., +92xxxxxxxxxx)",
        "password_error": "Passwords do not match",
        "next_button": "Next",
        "back_button": "Go Back & Edit"
      },
      "step3": {
        "progress_label": "Step 3: Confirm Details",
        "progress_count": "3/4",
        "title": "Confirm Your Details",
        "email_label": "Email",
        "full_name_label": "Full Name",
        "username_label": "Username",
        "phone_label": "Phone Number",
        "dob_label": "Date of Birth",
        "interests_label": "User Interests",
        "terms_text": "I agree to the",
        "terms_link": "Terms of Service",
        "and_text": "and",
        "privacy_link": "Privacy Policy",
        "submit_button": "Confirm & Create Account",
        "submitting": "Submitting...",
        "back_button": "Go Back & Edit",
        "error": "Registration failed. Please try again."
      },
      "step4": {
        "title": "Thank you for registering with us.",
        "subtitle": "Please verify your email",
        "sent_to": "We've sent a verification link to:",
        "check_inbox": "Please check your inbox and click the link to verify your email.",
        "expires": "Link expires in 12 hours.",
        "login_button": "Go to Login",
        "resend_text": "Didn't receive the email?",
        "resend_link": "Resend",
        "resend_toast": "Verification email resent to {{email}}"
      },
      "email_exists": {
        "title": "This email is already registered",
        "body": "If you haven't verified yet, we can resend your verification link.",
        "resend_button": "Resend verification email",
        "resending": "Resending...",
        "login_button": "Go to Login",
        "resend_toast": "If an account exists for {{email}}, a verification email has been sent.",
        "resend_error": "We couldn't resend the verification email. Please try again."
      },
      "email_verified": {
        "title": "This email is already verified",
        "body": "Your account is ready. Please sign in to continue.",
        "login_button": "Go to Login"
      },
      "interests": {
        "cybersecurity": "Cybersecurity",
        "privacy": "Privacy",
        "networking": "Networking",
        "development": "Development",
        "other": "Other"
      },
      "common": {
        "signin_text": "Already have an account?",
        "signin_link": "Sign In"
      }
    }
  },
  "dashboards": {
    "company_user": {
      "eyebrow": "Live Range Operations",
      "greeting": "Welcome back.",
      "subtitle": "Track your training progress and active laboratory nodes.",
      "status_connected": "Connected",
      "stat_trainings": "Trainings Assigned",
      "stat_flags": "Flags Captured",
      "stat_hours": "Training Hours",
      "stat_achievements": "Achievements",
      "topology_title": "Target Range Subnet Topology",
      "console_title": "Range Console Diagnostics",
      "diagnostics_online": "Diagnostics Online",
      "clear_terminal": "Clear Terminal",
      "active_trainings": "Active Trainings",
      "explore_catalog": "Explore Catalog",
      "skill_index": "Cyber Skill Index",
      "recent_achievements": "Recent Achievements"
    }
  },
  "navbar": {
    "brand": "Quantum Omnirange",
    "links": {
      "dashboard": "Dashboard",
      "boxes": "Boxes",
      "topology": "Topology"
    },
    "search_placeholder": "Search...",
    "search_aria": "Search",
    "user_menu_aria": "User menu",
    "user": {
      "profile": "Profile",
      "settings": "Settings",
      "logout": "Logout",
      "default_name": "User"
    },
    "logging_out": "Logging out..."
  },
  "footer": {
    "brand": "Quantum Omnirange",
    "description": "Secure your digital infrastructure with advanced cybersecurity training and monitoring.",
    "sections": {
      "platform": "Platform",
      "resources": "Resources",
      "company": "Company"
    },
    "platform_links": {
      "dashboard": "Dashboard",
      "boxes": "Boxes",
      "topology": "Topology"
    },
    "resources_links": {
      "documentation": "Documentation",
      "api_reference": "API Reference",
      "support": "Support"
    },
    "company_links": {
      "about_us": "About Us",
      "contact": "Contact",
      "privacy_policy": "Privacy Policy"
    },
    "bottom": {
      "copyright": "© {{year}} Quantum Omnirange. All rights reserved.",
      "terms_of_service": "Terms of Service",
      "privacy_policy": "Privacy Policy"
    }
  },
  "topology": {
    "builder_title": "Topology Builder",
    "builder_description": "Design, connect, and deploy your custom cyber range network.",
    "ai": {
      "title": "AI Architect",
      "history": "History",
      "placeholder": "Describe your topology...",
      "welcome": "Hello! I'm your AI topology assistant. Describe what you want to build and I'll generate it for you."
    },
    "device_library": {
      "title": "Device Library",
      "search_placeholder": "Search devices..."
    },
    "devices": {
      "other": "Other"
    },
    "actions": "Actions",
    "preview_json": "Preview JSON",
    "import_topology": "Import Topology",
    "reset_canvas": "Reset Canvas",
    "sync": {
      "sync_topology": "Sync topology",
      "sync_topology_with_current_ai_session": "Sync topology with current AI session",
      "syncing": "Syncing...",
      "synced": "Synced!",
      "failed_to_sync": "Failed to sync topology",
      "failed_to_sync_with_current_ai_session": "Failed to sync topology with current AI session"
    },
    "my_topologies": {
      "my_topologies": "My Topologies",
      "recent_topologies": "Recent Topologies",
      "no_topologies_yet": "No topologies yet. Submit a design to see it here.",
      "unnamed": "Unnamed",
      "no_description": "No description available",
      "columns": {
        "name": "Name",
        "title": "Title",
        "nodes": "Nodes",
        "edges": "Edges"
      }
    },
    "default_topologies": {
      "default_topologies": "Default Topologies",
      "available_defaults": "Available Defaults",
      "no_default_topologies": "No default topologies available right now."
    },
    "submit_topology": {
      "name_this_topology": "Name this topology",
      "give_topology_name": "Give your topology a name before submitting. This name will be used to identify it in My Topologies.",
      "e_g_production_web_tier": "e.g. Production Web Tier",
      "submit": "Submit Topology"
    }
  }
}
